import React from 'react';
import { ChevronRight } from 'lucide-react';

// Rows-per-page selector + prev/next pager. Page-math (range label, disabled
// states, clamping) is computed here from the parent-owned pagination state.
export const PaginationFooter = ({
    currentPage,
    itemsPerPage,
    totalJobs,
    onChangeItemsPerPage,
    onPrevPage,
    onNextPage,
}) => {
    const totalPages = Math.ceil(totalJobs / itemsPerPage);

    return (
        <div className="px-4 py-3 border-t border-gray-200 bg-gray-50 flex items-center justify-between">
            <div className="flex items-center gap-2">
                <span className="text-sm text-gray-600">Rows per page:</span>
                <select
                    value={itemsPerPage}
                    onChange={(e) => onChangeItemsPerPage(Number(e.target.value))}
                    className="text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 bg-white py-1 pl-2 pr-8"
                >
                    {[10, 20, 30, 50].map(size => (
                        <option key={size} value={size}>{size}</option>
                    ))}
                </select>
            </div>

            <div className="flex items-center gap-4">
                <span className="text-sm text-gray-600">
                    {(currentPage - 1) * itemsPerPage + 1}-
                    {Math.min(currentPage * itemsPerPage, totalJobs)} of {totalJobs}
                </span>
                <div className="flex items-center gap-1">
                    <button
                        type="button"
                        onClick={onPrevPage}
                        disabled={currentPage === 1}
                        className="p-1 rounded-md hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        <div className="w-5 h-5 flex items-center justify-center transform rotate-180">
                            <ChevronRight size={16} />
                        </div>
                    </button>
                    <button
                        type="button"
                        onClick={onNextPage}
                        disabled={currentPage >= totalPages}
                        className="p-1 rounded-md hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        <ChevronRight size={16} />
                    </button>
                </div>
            </div>
        </div>
    );
};
